module.exports = __webpack_public_path__ + "c7195bdf41760ec395d1712a73396761.png";